import {
  QUERY_KEY_USER_ALL_AVATARS,
  QUERY_KEY_USER_ALL_FRAMES,
} from './../../utils/constants/query-key';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import {
  QUERY_WEBCOIN_LIVE_FRAMES_AND_AVATARS,
  QUERY_WEBCOIN_USD_TO_WEBCOIN_RATE,
} from '../../utils/constants/query-key';
import {
  getAllUserAvatars,
  getAllUserFrames,
  getLiveFramesAndAvatars,
  getUsdToWebCoinRate,
} from '@wwe-portal/web/services/client/webcoin';

export const useGetLiveFramesAndAvatars = () => {
  return useQuery({
    queryKey: [QUERY_WEBCOIN_LIVE_FRAMES_AND_AVATARS],
    queryFn: getLiveFramesAndAvatars,
  });
};

export const useInvalidateLiveFramesAndAvatars = () => {
  const queryClient = useQueryClient();
  return async () => {
    await queryClient.invalidateQueries({
      queryKey: [QUERY_WEBCOIN_LIVE_FRAMES_AND_AVATARS],
    });
  };
};

export const useGetUsdToWebCoinRate = () => {
  return useQuery({
    queryKey: [QUERY_WEBCOIN_USD_TO_WEBCOIN_RATE],
    queryFn: getUsdToWebCoinRate,
  });
};

export const useGetAllAvatars = () => {
  return useQuery({
    queryKey: [QUERY_KEY_USER_ALL_AVATARS],
    queryFn: getAllUserAvatars,
  });
};

export const useGetAllFrames = () => {
  return useQuery({
    queryKey: [QUERY_KEY_USER_ALL_FRAMES],
    queryFn: getAllUserFrames,
  });
};
